export type ParserConfigDto = {
  id: number;
  name?: string;
  parserName: string;
  description: string;
  connectionTypeId: number;
  connectionTypeName: string;
  payloadTypeId: number;
  payloadTypeName: string;
};

export enum PayloadTypeId {
  Json = 1,
  ByteArray = 2,
}
